export default __webpack_public_path__ + "static/media/bg21.948ca261.jpg";